import posthog from 'posthog-js';

export function usePostHog() {
  if (typeof window !== 'undefined') {
    posthog.init('phc_XAhufrm0QtfjIoqdX4hSetr40bB17KboY22Zyemmf1L', {
      api_host: 'https://eu.i.posthog.com',
    });
  }

  return {
    posthog,
  };
}
